import React, { useState, useEffect } from "react"
import "bootstrap/dist/css/bootstrap.min.css"
import { Helmet } from "react-helmet"
import CircularProgress from '@material-ui/core/CircularProgress'
import "./Layout.scss"

import Topbar from "./Topbar"
import Footer from "./Footer"
import ModelSelector from './ModelSelector'

import favicon from "../../../static/favicon.png"

import navigation from '../../data/navigation.json'

function Layout ({children, title, getModel}) {

  const [loading, setLoading] = useState(true)

  useEffect(() => {

    setTimeout(() => {setLoading(false)}, 3000);

  },[])
  
  return (
    <div className="Layout">
      <div className={loading ? "MRSAM_loading" : "MRSAM"}>
        <Helmet>
          <meta charSet="utf-8" />
          <meta name="viewport" content="width=device-width, initial-scale=1.0" />
          <link rel="icon" type="image/png" href={favicon}/>
          <title>{title}</title>
          <link rel="canonical" href="http://mysite.com/example" />
        </Helmet>

        <Topbar matrices={navigation[3].items} >
          <ModelSelector getModel={(value) => getModel(value)} matrices={navigation[3].items} />
        </Topbar>

        {children}

        <Footer />
      </div>

      <div className={loading ? "loading" : "loading_hidden"}>
        <CircularProgress />
        <h5>Building application..</h5>
      </div>
    </div>
  )
}

export default Layout